import React, { useCallback } from "react";
import { useGetTriggersQuery } from "../../../../../services/api/repositories/TriggersRepository";
import { Form } from "react-bootstrap";


function TriggerInput({tabIndex, trigger, setTrigger, triggerValidationError, triggerIsSetByUser, setTriggerIsSetByUser}:
    {
        tabIndex: number, 
        trigger: string, 
        setTrigger: (trigger: string) => void,  
        triggerValidationError: string, 
        triggerIsSetByUser: boolean, 
        setTriggerIsSetByUser: (triggerIsSetByUser: boolean) => void
    })  
    {

        const triggersQuery = useGetTriggersQuery();

        const handleChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
            setTrigger(event.target.value);
            if (setTriggerIsSetByUser) {
                setTriggerIsSetByUser(false);
            }
        }, [setTrigger, setTriggerIsSetByUser]);

        return (
            <Form.Group  className="form-group trigger required">
                <Form.Label className="form-label" htmlFor="mailing-trigger-select">Déclencheur</Form.Label>
                <Form.Select 
                    className="form-select" 
                    id="mailing-trigger-select" 
                    tabIndex={tabIndex} 
                    required 
                    onChange={handleChange}
                    isInvalid={triggerValidationError !== null && triggerIsSetByUser}
                    value={trigger ? trigger : "none"} 
                >
                    <option value="none" disabled>Sélectionner un Déclencheur</option>
                    {triggersQuery.isLoading && <option>Chargement...</option>}
                    {!triggersQuery.isLoading && triggersQuery.data?.triggers && 
                        triggersQuery.data.triggers.map(trigger => <option key={trigger.uuid} value={trigger.uuid}>{trigger.name}</option>)
                    }
                </Form.Select>
                <Form.Control.Feedback type="invalid">{triggerValidationError}</Form.Control.Feedback>
            </Form.Group >
        );
    }

export default TriggerInput;